export default function LogoLoader() {
  return (
    <div className="logo-loader" data-testid="logo-loader">
      <div className="logo-loader-inner">
        {/* Geometric logo with tile assembly animation */}
        <div className="logo-assemble-container">
          {/* Animated tile overlay grid - creates the assembly illusion */}
          <div className="logo-tiles-grid">
            <div className="logo-tile tile-1"></div>
            <div className="logo-tile tile-2"></div>
            <div className="logo-tile tile-3"></div>
            <div className="logo-tile tile-4"></div>
            <div className="logo-tile tile-5"></div>
            <div className="logo-tile tile-6"></div>
            <div className="logo-tile tile-7"></div>
            <div className="logo-tile tile-8"></div>
            <div className="logo-tile tile-9"></div>
            <div className="logo-tile tile-10"></div>
            <div className="logo-tile tile-11"></div>
            <div className="logo-tile tile-12"></div>
          </div>
          {/* Actual logo image revealed as tiles assemble */}
          <img 
            src="/brand/byard-logo.jpg"
            alt="Backyard Logo"
            className="logo-geometric-img"
          />
        </div>
        
        {/* Wordmark image */}
        <div className="logo-wordmark-container">
          <img 
            src="/brand/byard-logo-acronym.jpg"
            alt="BACKYARD"
            className="logo-wordmark-img"
          />
        </div>
      </div>
    </div>
  );
}